module.exports = __webpack_public_path__ + "static/6-7722856604dd17bbc78b2ef53494884f.jpg";